











import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

import buffs from "@/config/wow/buffs";

import Buff from "@/components/composition/components/Buff.vue";

interface Character {
	class: number;
}

@Component({
	components: {Buff}
})
export default class BuffList extends Vue {
	buffs = buffs;

	@Prop({required: true})
	characters!: Character[];
}
